import { Injectable } from '@angular/core';
import { AjaxErrorHandler } from './models/ajax-error-handler';
import { AjaxErrorInfo } from './models/ajax-error-info';
import { CustomMessageService } from './message.service';
import { ApplicationMessage } from './models/application-message';
import { MessageType } from './models/enum/message-type';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from './auth.service';

@Injectable()
export class DefaultAjaxErrorHandlerService implements AjaxErrorHandler {
  public handle(errorInfo: AjaxErrorInfo) {
    let userMessage = new ApplicationMessage();
    userMessage.type = MessageType.Error;

    let ts = this.translateService;

    userMessage.summary = ts.instant('error');
    userMessage.sourceId = 'global';

    if (errorInfo.isServerError) {
      userMessage.detail = ts.instant('ServerError');
    } else if (errorInfo.isConnectionError) {
      userMessage.detail = ts.instant('ConnectionError');
    } else if (errorInfo.isUnauthorized) {
      userMessage.detail = ts.instant('Unauthorized');
    } else if (errorInfo.isSessionExpired) {
      userMessage.detail = ts.instant('SessionExpired');
    } else if (errorInfo.isPermissionDenied) {
      userMessage.detail = ts.instant('PermissionDenied');
    } else {
      userMessage.detail = ts.instant('UnknowErrorContactAdministrator');
    }

    if (errorInfo.isUnauthorized || errorInfo.isSessionExpired) {
      setTimeout(() => {
        this.authService.logout().subscribe();
      }, 2000);
    }

    this.messageService.pushMessage(userMessage);
  }

  constructor(
    private messageService: CustomMessageService,
    private translateService: TranslateService,
    private authService: AuthService
  ) {}
}
